export default __webpack_public_path__ + "static/media/17-2.0ac13a59.png";